import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AbbDashboardComponent } from './abb-dashboard.component';

export const AbbDashboardRoutes: Routes = [
  {
    path: 'abb-dashboard',
    component: AbbDashboardComponent,
    data: {
      'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin', 'Operation', 'IT']
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(AbbDashboardRoutes)],
  exports: [RouterModule]
})
export class AbbDashboardRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard-routing.module.ts